import { render, staticRenderFns } from "./ConfigurationsOverviewStep.vue?vue&type=template&id=563a4b12&scoped=true&"
import script from "./ConfigurationsOverviewStep.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationsOverviewStep.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationsOverviewStep.vue?vue&type=style&index=0&id=563a4b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a4b12",
  null
  
)

export default component.exports